module.exports = __webpack_public_path__ + "media/images/top/about-bg-424b3dd4b07d290e32e77c17d69fb451.webp";